import { AssignedModule, TrendValue } from '../_types';

// Assigned module configurations
export const ASSIGNED_MODULES: AssignedModule[] = [
  { key: 'internal-affairs', name: 'Internal Affairs' },
  { key: 'use-of-force', name: 'Use of Force' },
  { key: 'vehicle-pursuits', name: 'Vehicle Pursuits' },
  { key: 'field-investigation', name: 'Field Investigation' },
  { key: 'employee-conduct', name: 'Employee Conduct' },
  { key: 'vehicle-damage', name: 'Vehicle Damage' },
];

// Subject identifiers for tooltip formatting
export const SUBJECT_IDENTIFIERS: Record<string, string> = {
  'internal-affairs': 'case',
  'use-of-force': 'incident',
  'vehicle-pursuits': 'pursuit',
  'field-investigation': 'investigation',
  'employee-conduct': 'complaint', // Context-dependent, default to complaint
  'vehicle-damage': 'incident',
};

// Trend label mappings
export const TREND_LABELS: Record<TrendValue, string> = {
  UP: 'Rising',
  DOWN: 'Falling',
  NEUTRAL: 'Neutral',
  FLAT: 'Flat',
  UNKNOWN: 'Unknown',
};

// Helper to get subject identifier for a module
export const getSubjectIdentifier = (assignedModule: string): string => {
  return SUBJECT_IDENTIFIERS[assignedModule] || 'item';
};

// Helper to format tooltip description
export const formatTooltipDescription = (
  value: number,
  total: number,
  subject: string
): string[] => {
  const percentage = total > 0 ? Math.round((value / total) * 100 * 10) / 10 : 0;
  // Format to 1 decimal place, but remove .0 if it's a whole number
  const percentageStr = percentage % 1 === 0 ? percentage.toString() : percentage.toFixed(1);
  const subjectPlural = value === 1 ? subject : `${subject}s`;
  return [`${value} ${subjectPlural} (${percentageStr}% of total)`];
};

